import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import numeral from "numeral";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    // Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
    Breadcrumbs,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const SalesOrderListing = () => {
    const [posts, setPosts] = useState([]);
    const [totalAmount, setTotalAmount] = useState("");
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
    const [downloadFlag, setDownloadFlag] = useState(true);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
    const classes = useStyles();
    // console.log(format(dateRange.startDate, "yyyy/MM/dd/"));
    // console.log(format(dateRange.endDate, "yyyy/MM/dd/"));
    const [branchidNo, setbranchidNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
        setDataLoaded(true);
    }, []);
    
    useEffect(() => {
        if(posts.length > 0){
            setDownloadFlag(true);
        }
    }, [posts]);
    
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

    //search button
	const dataFilter = async () => {
        setDataLoaded(false);
         await axios.get(
                process.env.REACT_APP_API_URL+'get_so_listing', {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: branchidNo,  //branchidNo
            }
        }).then(function (res) {
			setPosts(res.data.data);
            setTotalAmount(res.data.totalAmount);
		  }).catch(function (error) {	
			// console.log(error);
		  });
        setDataLoaded(true);
    }

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
    };

    const columns = [
            {
                name: "date",
                label: "Date",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
            {
                name: "name",
                label: "Name",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
            {
                name: "drno",
                label: "DR No",
                options: {
                    filter: false,
                    // display: "excluded",
                },
            },
            {
                name: "dr_amount",
                label: "Dr Amount",
                options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                    
                        return (
                                <div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
                                // <div>{numeral(value).format('0,0.00')}</div>
                        );
                    }
                }
            },
			{
				name: "drno",
				label:"Actions",
				options: {
				  customBodyRender: (value, tableMeta, updateValue) => {
					//salesorderviewreference.php (drno) (attach when Sales Order module is done)
					return (
                        <NavLink to={"/sales/sales-order-history-view-ref/"+value+"/"+branchidNo}>
                            <Button variant="contained" color="primary">
                            View
                            </Button>	
                        </NavLink> 
					);
				  },download: false 
				}
			}
        ];
 
        const options = {
            filter: false,
            viewColumns: false,
            // filter: true,
            // filterType: "dropdown",
            selectableRows: "none",
            filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
            download: false,  //add this
            print: false, //add this 
            downloadOptions: {
				filename : 'SalesOrderListing.csv' //change filename of csv
			}
            // tableBodyHeight,
        };

        const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink to="/reports">
                                    <h2 className="header-title">Reports</h2>
                                </NavLink>
                                <Typography color="textPrimary">Sales Order Listing</Typography>
                            </Breadcrumbs>
            			</div>
                        <div className="page-container">
                           <div style={style}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Select Date"
                                            variant="outlined"
                                            onFocus={() => setOpen(true)}
                                            fullWidth={true}
                                            autoComplete="off"
                                            value={`${format(
                                                dateRange.startDate,
                                                "MM/dd/yyyy"
                                            )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                        />
                                        <DateRangePicker
                                            open={open}
                                            toggle={toggle}
                                            onChange={(range) => dateRangeHandler(range)}
                                        /> 
                                    </Grid>
                                    <Grid item xs={1} lg={1} xl={1}>
                                        <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                                    </Grid>
                                </Grid>        
                            </div>
                        
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            								<h3 className="header-title" style={{color:"#339933"}}>
            									Sales Order Listing
            								</h3>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
                                
            				)}
                                <Grid  container justifyContent="flex-end" spacing={1} style ={{marginTop: "1%"}}>
                                    <Grid item xs={4}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Total"
                                            variant="outlined"
                                            fullWidth={true}
                                            autoComplete="off"
                                            value={totalAmount}
                                            InputProps={{
                                                readOnly: true,
                                              }}
                                        />

                                    </Grid>
                                </Grid> 

            			</div>
            		</div>
            	);
};
 
export default SalesOrderListing;